import React, { FC } from 'react';
import { MenuItem, SelectChangeEvent } from '@mui/material';

import { IAbsenceType, ICreateAbsenceRequestDTO } from 'src/api/dtos';
import { Select } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

type InputsType = Partial<Pick<ICreateAbsenceRequestDTO, 'absenceTypeId'>>;

interface Props {
  absenceTypes: IAbsenceType[];
  absenceTypeId: number | undefined;
  onUpdate: (inputs: InputsType) => void;
}

export const AbsenceTypeSelect: FC<Props> = ({ absenceTypes, absenceTypeId, onUpdate }) => {
  const { t } = useTranslate();

  const handleAbsenceTypeChange = (event: SelectChangeEvent) => {
    const newInputs: InputsType = { absenceTypeId: Number(event.target.value) };

    onUpdate(newInputs);
  };

  return (
    <>
      <label className="small mb-2 fw-medium d-block required">{t('absences.selectAbsenceType')}</label>
      <Select
        className="w-75"
        label={t('absences.exVacationUnpaidAbsenceEtc')}
        value={absenceTypeId || ''}
        onChange={handleAbsenceTypeChange}
      >
        {absenceTypes.map((type, index) => (
          <MenuItem key={index} value={type.id}>
            {type.description}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
